import { ADD_GROUP_SUCCESS, ADD_GROUP_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case ADD_GROUP_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case ADD_GROUP_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
